import React from 'react';

import CardBoletosMobile from './cardBoletosMobile';
import CardBoletosDesktop from './cardBoletosDesktop';

export const ResumoBoletos = ({
  parcelas,
  tema,
  geracaoBoleto,
  contratoSelecionado,
}) => {
  return (
    <>
      <CardBoletosMobile
        parcelas={parcelas}
        tema={tema}
        geracaoBoleto={geracaoBoleto}
        contratoSelecionado={contratoSelecionado}
      />

      <CardBoletosDesktop
        parcelas={parcelas}
        tema={tema}
        geracaoBoleto={geracaoBoleto}
        contratoSelecionado={contratoSelecionado}
      />
    </>
  );
};

export default ResumoBoletos;
